module.exports = __webpack_public_path__ + "img/imagelogementdefault-.8595bdea.jpg";